import { React, useState } from "react";
import Person3Icon from '@mui/icons-material/Person3';
import ForumIcon from '@mui/icons-material/Forum';
import BannerBreadcrumb from "../Components/BannerBreadcrumb";
const BlogDescription = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        type: "Blog"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});

    const validate = () => {
        const errors = {};
        // Name: only letters and spaces
        if (!/^[a-zA-Z\s]*$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        // Phone: must be 10 digits, numeric only
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        // Email: basic email regex
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        // For phone, allow only digits
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        // For name, allow only letters and spaces
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                type: "Blog"
            });
        } catch (err) {
            console.error("Error submitting form:", err);
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    return (
        <>
            <BannerBreadcrumb head={"Blog Description"} pagename={"Blog Description"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility ">
                            <h5 className="about-head mb-4">Unraveling Internship Process in the US: Overcoming Obstacles and Exploring Tech Opportunities in San Francisco</h5>
                            <img src="/images/blog.jpg" alt="Blog Image" className="img-fluid mb-4" />
                            <p className="loan-elegibility-des">Credere Finance provides personal insights from Suresh, an international student studying MS in CS in the US, on how to find internships in the US.
                                <br />
                                With goals of a bright future, I enthusiastically went on the search to get an internship. I had no clue that hunting for an internship may be more challenging than getting full-time employment at times.
                                <br /><br />Join me as I navigate the ups and downs of my internship quest. I will share insights into the distinct elements of pursuing an internship, tackling the challenges of a competitive environment, and ultimately discovering the key to maximizing your internship experience.</p>
                            <h5 className="about-head"> The Struggle to Secure an Internship</h5>
                            <p className="loan-elegibility-des">Obtaining an internship can sometimes seem like a challenging task, with numerous obstacles to conquer.</p>
                            <h5 className="about-head">Strong competition </h5>
                            <p className="loan-elegibility-des">It became clear to me in a short period of time that a single internship could receive an astounding number of applications, anywhere between 700 and 1000, within a few days. The sheer amount of competition was truly daunting.</p>
                            <h5 className="about-head">Few available positions </h5>
                            <p className="loan-elegibility-des">The scarcity of internship positions in companies contributes to a highly competitive and uncertain environment.</p>
                            <h5 className="about-head">The Impact of Building Connections </h5>
                            <p className="loan-elegibility-des"><li>One of the most vital lessons I learned throughout my internship was the significance of networking in the whole process. It became clear to me that communication is an essential aspect that cannot be overlooked.</li>
                                <li>Industry events like conferences, meetups, and gatherings have given me the opportunity to connect with professionals who may offer valuable internship opportunities.</li><li>LinkedIn and other online networking platforms have become my go-to virtual playground for expanding my professional network. These platforms have allowed me to connect with individuals from my sector while engaging in major conversations. This has not only helped me build valuable connections.</li><li>Useful Interviews: Setting up informative interviews with experts transformed everything. These discussions provided opportunities to find out about their career plans and occasionally uncovered internship opportunities.</li>
                            </p>
                            <h5 className="about-head">Applying Early Increases your Chances of Getting the Internship</h5>
                            <p className="loan-elegibility-des">
                            <li>I learned about the value of time in internship applications.</li>
                            <li>Companies require applications to be submitted as early as two semesters before the start of the internship. It was essential to submit your application before time to maximize your chances of getting the job.</li>
                            <li>I made sure to start preparing my application materials early, tailoring them specifically for each company.</li>
                            <li>Connecting with professionals in my field has given me valuable information on when certain companies typically announce internship opportunities. This has allowed me to stay ahead of the game and increase my chances of securing a position.</li>
                            <li>Newly introduced paid services provide access to guaranteed remote internships. These services showcase a variety of potential opportunities and connect users with recruiters in the field.</li>
                            </p>
                            <h5 className="about-head">Tech and Innovation Hub of San Francisco</h5>
                            <p className="loan-elegibility-des">
                            San Francisco, California, is a dream destination for those aspiring in the tech industry.<br></br>
                            <br></br><strong>Innovation Center:</strong> The city is a prime location for leading technology companies such as Apple, Google, and Facebook, offering unique access to innovative projects and collaborations.<br></br>
                            <br></br>The dynamic tech ecosystem in San Francisco created a wealth of networking opportunities.
                            <br></br>These valuable interactions allowed individuals to connect with professionals and ptivate meaningp relationships. By embracing these changes, new doors of opportunity could potentially be opened.<br></br>
                            <br></br>Diversity and inclusion are highly valued in the city, making it a great place to work and study.
                            </p>

                            <h5 className="about-head">My Strength Story: Meeting Challenges Directly</h5>
                            <p className="loan-elegibility-des">
                            I realized that facing obstacles head-on and using clever strategies could make a difference.<br></br>
                            <br></br><strong>Developing Skills:</strong> I started exploring personal projects, freelancing, and volunteer work to develop my skills and gain more experience in my search for internships.<br></br>
                            <br></br><strong>Prioritizing Quality Over Quantity:</strong> Rather than using a broad approach, I shifted my focus towards submitting high-quality applications that were specifically tailored to positions that truly caught my attention.<br></br>
                            <br></br><strong>Welcoming Different Opportunities:</strong> Through exploring internships at emerging companies as well as non-governmental organizations, I found that these groups were frequently more willing to offer guidance to interns.<br></br>
                            </p>

                            <h5 className="about-head">Conclusion</h5>
                            <p className="loan-elegibility-des">
                            As I look back on my internship experience, I see just how crucial it is to be fearless, persistent, and responsive to new opportunities.
                            <br></br>Each obstacle I encountered offered me growth, insight, and direction.
                            </p>


                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                {/* <form className="loan-check-form" style={{ padding: "50px" }}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Need Help in education loan?</h4>
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input type="text" className="form-control finance-input" placeholder="E.g. Priya Senger" />
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input type="text" className="form-control finance-input" placeholder="E.g. priya@doe.com" />
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input type="tel" className="form-control finance-input" placeholder="E.g. 8888880000" />
                                        </div>
                                        <div className="col-12">
                                            <button type="button" className="loan-btn w-100 mt-3">Register Now</button>
                                        </div>


                                    </div>
                                </form> */}
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Need Help in education loan?</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3">Register Now</button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Best Landing Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default BlogDescription;